'use client';

import { Chip } from '@mui/material';

type CategoryChipProps = {
  label: string;
  isActive: boolean;
  onClick: () => void;
  tag_slug?: string;
};

export function CategoryChip({ label, isActive, onClick, tag_slug }: CategoryChipProps) {
  return (
    <Chip
      label={label}
      onClick={onClick}
      data-tag-slug={tag_slug}
      sx={{
        fontWeight: 500,
        fontSize: '0.875rem',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        bgcolor: isActive ? 'primary.main' : 'background.paper',
        color: isActive ? 'white' : 'text.primary',
        border: '1px solid',
        borderColor: isActive ? 'primary.main' : 'divider',
        borderRadius: '18px',
        height: 34,
        px: 2,
        '& .MuiChip-label': {
          px: 0,
        },
        '&:hover': {
          bgcolor: isActive ? 'primary.dark' : 'action.hover',
          borderColor: isActive ? 'primary.dark' : 'divider',
        },
      }}
    />
  );
}

export default CategoryChip;
